import {apiV2} from '../api';
import VotingRadioButtonsSearchFieldActions from 'actions/search/VotingRadioButtonsSearchFieldActions';

const VotingRadioButtonsSearchFieldSource = {
  fetchTeams: {
    remote(state) {
      return apiV2.get('/teams_within_user_perms');
    },
    success: VotingRadioButtonsSearchFieldActions.fetchTeamsSuccess,
    error: VotingRadioButtonsSearchFieldActions.fetchTeamsError,
  },

  fetchDepartments: {
    remote(state) {
      return apiV2.get('/departments_within_user_perms');
    },
    success: VotingRadioButtonsSearchFieldActions.fetchDepartmentsSuccess,
    error: VotingRadioButtonsSearchFieldActions.fetchDepartmentsError,
  },
};

export default VotingRadioButtonsSearchFieldSource;
